import { useMutation } from '@tanstack/react-query'

import type { TargetSoCRequest } from '@/features/resource/endpoints/resources'
import { cancelTargetSoC, setTargetSoC } from '@/features/resource/endpoints/resources'

/** POST a target-SoC command. Resolves with the BFF-generated `commandId` on any 2xx (202 today). */
export function useSetTargetSoCMutation() {
  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: (params: { resourceId: string; body: TargetSoCRequest }) =>
      setTargetSoC(params.resourceId, params.body),
  })

  return {
    setTargetSoC: mutateAsync,
    ...mutationResult,
  }
}

/** Cancel the active target-SoC command (POST .../target-soc/cancellation). No request body. */
export function useCancelTargetSoCMutation() {
  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: (params: { resourceId: string }) => cancelTargetSoC(params.resourceId),
  })

  return {
    cancelTargetSoC: mutateAsync,
    ...mutationResult,
  }
}
